import { FormTypes } from '@oneblink/types'
import _cloneDeep from 'lodash.clonedeep'

export function findAndRemoveInfoElements(elements: FormTypes.FormElement[]) {
  let receiptMessage = ''
  let helpMessage = ''
  let receiptLink = ''
  let linkToRestart = false
  let contactMessage = ''

  const elementsFiltered = elements.reduce((newElements, element) => {
    if (
      (element.type === 'form' ||
        element.type === 'page' ||
        element.type === 'repeatableSet') &&
      element.elements
    ) {
      const {
        elements: filteredPageElements,
        receiptMessage: returnedReceiptMessage,
        helpMessage: returnedHelpMessage,
        receiptLink: returnedReceiptLink,
        linkToRestart: returnedLinkToRestart,
        contactMessage: returnedContactMessage,
      } = findAndRemoveInfoElements(element.elements)
      if (returnedReceiptMessage) {
        receiptMessage = returnedReceiptMessage
      }
      if (returnedHelpMessage) {
        helpMessage = returnedHelpMessage
      }
      if (returnedReceiptLink) {
        receiptLink = returnedReceiptLink
      }
      if (returnedLinkToRestart) {
        linkToRestart = returnedLinkToRestart
      }
      if (returnedContactMessage) {
        contactMessage = returnedContactMessage
      }
      const _element = _cloneDeep(element)
      _element.elements = filteredPageElements
      newElements.push(_element)
    } else if (element.type === 'html') {
      switch (element.name) {
        case '__receiptPageInfo':
          receiptMessage = element.defaultValue
          break
        case '__helpDialogInfo':
          helpMessage = element.defaultValue
          break
        case '__receiptLinkInfo':
          receiptLink = element.defaultValue
          break
        case '__receiptContactInfo':
          contactMessage = element.defaultValue
          break
        default:
          newElements.push(element)
      }
    } else if (element.type === 'boolean') {
      switch (element.name) {
        case '__linkToRestart':
          linkToRestart = element.defaultValue
          break
        default:
          newElements.push(element)
      }
    } else {
      newElements.push(element)
    }
    return newElements
  }, [] as FormTypes.FormElement[])
  return {
    receiptMessage,
    helpMessage,
    receiptLink,
    linkToRestart,
    contactMessage,
    elements: elementsFiltered,
  }
}

export function getReceiptMessage(elements: FormTypes.FormElement[]) {
  const { receiptMessage } = findAndRemoveInfoElements(elements)
  return receiptMessage
}

export function getHelpMessage(elements: FormTypes.FormElement[]) {
  const { helpMessage } = findAndRemoveInfoElements(elements)
  return helpMessage
}

export function getReceiptLink(elements: FormTypes.FormElement[]) {
  const { receiptLink } = findAndRemoveInfoElements(elements)
  return receiptLink
}

export function removeInfoElements(elements: FormTypes.FormElement[]) {
  const { elements: filteredElements } = findAndRemoveInfoElements(elements)
  return filteredElements
}
